import { createServerFn } from "@tanstack/react-start";

import { requireClerkCoachAuth } from "~/lib/coach-middleware";
import { S3Middleware } from "~/lib/s3-middleware";
import {
  DeleteProgramTemplateSchema,
  GetTemplateResourceUploadUrlSchema,
  ProgramTemplateValuesSchema,
  UpdateProgramTemplateSchema,
} from "~/lib/schemas/program-template";

export const listProgramTemplatesFn = createServerFn({ method: "GET" })
  .middleware([requireClerkCoachAuth])
  .handler(async ({ context }) => {
    const { listProgramTemplates } =
      await import("~/lib/server/program-template");
    return listProgramTemplates(context.coach.id);
  });

export const createProgramTemplateFn = createServerFn({ method: "POST" })
  .middleware([requireClerkCoachAuth])
  .validator(ProgramTemplateValuesSchema)
  .handler(async ({ data, context }) => {
    const { createProgramTemplate } =
      await import("~/lib/server/program-template");
    return createProgramTemplate(context.coach.id, data);
  });

export const updateProgramTemplateFn = createServerFn({ method: "POST" })
  .middleware([requireClerkCoachAuth])
  .validator(UpdateProgramTemplateSchema)
  .handler(async ({ data, context }) => {
    const { updateProgramTemplate } =
      await import("~/lib/server/program-template");
    const { templateId, ...values } = data;
    return updateProgramTemplate(context.coach.id, templateId, values);
  });

export const deleteProgramTemplateFn = createServerFn({ method: "POST" })
  .middleware([requireClerkCoachAuth])
  .validator(DeleteProgramTemplateSchema)
  .handler(async ({ data, context }) => {
    const { deleteProgramTemplate } =
      await import("~/lib/server/program-template");
    return deleteProgramTemplate(context.coach.id, data.templateId);
  });

export const getTemplateResourceUploadUrlFn = createServerFn({
  method: "POST",
})
  .middleware([S3Middleware, requireClerkCoachAuth])
  .validator(GetTemplateResourceUploadUrlSchema)
  .handler(async ({ data, context }) => {
    const { buildTemplateResourceKey, getPresignedUploadUrl } =
      await import("~/lib/server/s3");
    const resourceId = crypto.randomUUID();
    const key = buildTemplateResourceKey({
      coachId: context.coach.id,
      resourceId,
      filename: data.filename,
    });
    const signed = await getPresignedUploadUrl({
      key,
      contentType: data.contentType,
    });
    return { resourceId, signed };
  });
